import { shape, string, number, arrayOf } from 'prop-types';

export const businessHoursPropTypes = shape({
  id: number.isRequired,
  day: string.isRequired,
  closingTime: string.isRequired,
  openingTime: string.isRequired,
  dispatchMethod: string
});

export const storePropTypes = shape({
  id: number,
  name: string,
  textAddress: string,
  latitude: string,
  longitude: string,
  pickUpWaitTime: number,
  phone: string,
  deliveryWaitTime: number,
  businessHours: arrayOf(businessHoursPropTypes)
});

export const productProptypes = shape({
  price: number,
  name: string,
  modifier: arrayOf({}),
  quantity: number
});

export const orderProptypes = shape({
  status: string,
  dispatchMethod: string,
  createdAt: string,
  promiseTime: number
});

export const currentSubsidiaryProptypes = shape({ name: string, phone: string });

export default storePropTypes;
